import { addDays } from '@/shared/lib/dates/add-days';
import { addMonths } from '@/shared/lib/dates/add-months';
import type { IsoDate } from '@/shared/lib/dates/iso-date';
import type { Task } from '../schemas/task';

/** The next due date of a repeating task done on `on`, or undefined if it does not repeat. */
export function nextDueOn(task: Task, on: IsoDate): IsoDate | undefined {
  const every = task.repeat_every;
  if (!every) return undefined;
  switch (task.repeat_unit ?? 'months') {
    case 'days':
      return addDays(on, every);
    case 'weeks':
      return addDays(on, every * 7);
    case 'months':
      return addMonths(on, every);
    case 'years':
      return addMonths(on, every * 12);
  }
}
